export const blockIconsBusinessandpaymentsPaidNew = (
	<span className='material-symbols-outlined'>paid</span>
);
